document.addEventListener("DOMContentLoaded", function () {
  const initialStock = 100;
  const decrementIntervalMinutes = 30;
  const decrementPattern = [2, 3, 4];
  const minimumStock = 20;

  function startOfDay() {
    const now = new Date();
    return new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      3,
      0,
      0
    ).getTime(); // 3:00 AM today
  }

  function calculateStock() {
    const now = Date.now();
    const startDate = startOfDay();

    if (now < startDate) {
      // If current time is before 3:00 AM, adjust to the previous day's 3:00 AM
      startDate.setDate(startDate.getDate() - 1);
    }

    // Calculate elapsed time in minutes since 3:00 AM
    const elapsedMinutes = Math.floor((now - startDate) / 60000);

    // Calculate number of decrements
    const decrements = Math.floor(elapsedMinutes / decrementIntervalMinutes);

    let totalDecrementAmount = 0;
    for (let i = 0; i < decrements; i++) {
      totalDecrementAmount += decrementPattern[i % decrementPattern.length];
    }

    let currentStock = initialStock - totalDecrementAmount;

    if (currentStock < minimumStock) {
      return minimumStock;
    }

    return currentStock;
  }

  function updateStockDisplay() {
    const stock = calculateStock();
    const displayText =
      stock <= minimumStock
        ? `Less than 20 left on sale`
        : `Only ${stock} left on sale`;

    if (document.getElementById("stock-count")) {
      document.getElementById("stock-count").innerText = displayText;
    }
  }

  updateStockDisplay();
  setInterval(updateStockDisplay, 60000);
});
